module.exports = __webpack_public_path__ + "img/goal-one-br.85fcb3b3.png";